import React from "react";
import formatBytes from "../../shared/formatBytes";
import PriceIncluded from "./price-included";
import "./pricing-plan-selector.scss";
import ErrorText from "../../shared/error-text";
import Tick from "./tick";

interface PricingPlanSelectorProps {
    pricingPlans: any[];
    selectedPricingPlan: number;
    onSelectPricingPlan: (pricingPlanType: number) => void;
    currencySymbol: string;
    includeTax: boolean;
}

const PricingPlanSelector: React.FC<PricingPlanSelectorProps> = ({
    pricingPlans,
    selectedPricingPlan,
    onSelectPricingPlan,
    currencySymbol,
    includeTax
}) => {

    if (!pricingPlans || pricingPlans.length === 0) {

        return <ErrorText>
            No pricing plans are available at this time.
        </ErrorText>;
    }

    return (
        <div className="pricing-plan-selector">
            {pricingPlans?.map((plan, index) => {
                const price = includeTax && plan.taxAmount ? plan.price + plan.taxAmount : plan.price;
                const isSelected = selectedPricingPlan === plan.pricingPlanType;
                const isDisabled = !plan.allowed;

                return (
                    <div
                        key={index}
                        className={`card payment-price-card ${isSelected ? "price-card-selected" : ""} ${isDisabled ? "price-card-disabled" : ""}`}
                        onClick={() => !isDisabled && onSelectPricingPlan(plan.pricingPlanType)}
                        style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
                    >
                        <div className="price-card-content">
                            <header className="price-card-header">
                                <div className="price-card-header-title is-size-5">
                                    {plan.name}
                                </div>
                            </header>
                            <div className="price-description">
                                {plan.description}
                            </div>
                            <div className="price-amount">
                                <span className="price-cost">
                                    <span dangerouslySetInnerHTML={{ __html: currencySymbol }}></span>
                                    {price}
                                </span>
                                {" "}Per month
                            </div>
                            <PriceIncluded included={`${plan.maxFilms ?? 'Unlimited'} active film${(plan.maxFilms ?? 2) > 1 ? 's' : ''}`} />
                            <PriceIncluded included={`${plan.maxCollaboratorsPerFilm ?? 'Unlimited'} users per film`} />
                            <PriceIncluded included={`${formatBytes(plan.maxBytes)} storage`} />
                            {isSelected ? (
                                <div className="price-selected-indicator">
                                    <Tick />
                                    Selected
                                </div>
                            ) : (
                                <div className="price-selected-placeholder"></div>
                            )}
                            {isDisabled && (
                                <div className="price-disabled-overlay">
                                    Not Available
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default PricingPlanSelector;
